export const dietaryOptions = ['Vegan', 'Vegetarian']
export const allergens = [
    'Celery', 'Crustaceans', 'Eggs', 'Fish', 'Lupin', 'Cereals containing Gluten', 'Milk',
    'Molluscs', 'Mustard', 'Peanuts', 'Sesame', 'Soybeans', 'Sulphur dioxide / sulphites', 'Tree Nuts'
]